function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0795 5.14048L15.6864 5.6603C16.7091 5.80764 17.1189 7.06399 16.38 7.78609L13.7733 10.3327C13.4798 10.6195 13.3463 11.0323 13.416 11.4367L14.0363 15.0276C14.2122 16.0459 13.1442 16.8239 12.2289 16.3442L9.00138 14.6523C8.6379 14.4619 8.20393 14.4623 7.84101 14.6536L4.61747 16.3533C3.70342 16.8353 2.6334 16.0598 2.8068 15.0411L3.41848 11.4487C3.48728 11.0441 3.35287 10.6315 3.05856 10.3455L0.446318 7.80502C-0.29452 7.08461 0.112266 5.82733 1.13486 5.67755L4.74044 5.14929C5.14648 5.08986 5.49721 4.83436 5.6783 4.46619L7.28726 1.19634C7.74353 0.269169 9.06493 0.267482 9.52327 1.19372L11.1399 4.45963C11.3219 4.82723 11.6732 5.08199 12.0795 5.14048Z",
  fill: "#E5E5E5"
});

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.77919a02.svg";
export { ForwardRef as ReactComponent };